// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3aoKo","col":"styles_col__1qJWf"};